import moment from 'moment';

angular.module('magpieFlow', [
  'ui.bootstrap',
  'magpieLineage',
  'magpieUtil'
]).
directive('magpieJobDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-details.html',
    controller: function($scope) {
      $scope.tasks = $scope.tasks || [];
      $scope.tasks.forEach(function(task) {
        const predList = $scope.tasks.filter((t) => t.taskId === task.predecessor);

        if (predList.length > 0) {
          task.predecessorName = predList[0].name;
        }

        task.successorNames = task.successors.map(function(tId) {
          const tList = $scope.tasks.filter((t) => t.taskId === tId);
          return tList.length > 0 ? tList[0].name: null;
        });
      });

      $scope.regularTasks = $scope.tasks.filter((t) => !t.isFinalizer);
      $scope.finalizerTasks = $scope.tasks.filter((t) => t.isFinalizer);

      const startTask = _.find($scope.tasks, (t) => t.taskId === $scope.job.startTask);

      if (startTask) {
        $scope.startTask = startTask.name;
      }
    }
  };
}).
directive('magpieTask', function() {
  return {
    restrict: 'E',
    scope: {
      description: '=?',
      task: '=?'
    },
    templateUrl: 'components/magpie-display/flow/task.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.task = $scope.description.task;
        $scope.executionHistory = $scope.description.history;
      }
    }
  };
}).
directive('magpieTaskDetails', function() {
  return {
    restrict: 'E',
    scope: {
      task: '=',
      containsNestedJobGraph: '=?',
      openNestedJob: '&?'
    },
    templateUrl: 'components/magpie-display/flow/task-details.html'
  };
}).
directive('magpieJob', function() {
  return {
    restrict: 'E',
    scope: {
      lineage: '=?',
      job: '=?',
      tasks: '=?',
      schedules: '=?',
      description: '@?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/flow/job.html',
    controller: function($scope) {
      if ($scope.description) {
        const description = JSON.parse($scope.description);

        $scope.hasJobGraph = description.graph &&
          description.graph.nodes &&
          description.graph.nodes.length > 0;

        if ($scope.hasJobGraph) {
          $scope.jobGraph = JSON.stringify(description.graph);
          $scope.active = 0;
        }

        $scope.job = description.job;
        $scope.lineage = description.lineage;
        $scope.executionHistory = description.history;
        $scope.tasks = description.tasks;
        $scope.schedules = description.schedules;
        $scope.userPermissions = description.userPermissions;
      }
    }
  };
}).
directive('magpieJobGraph', function($timeout) {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-graph.html',
    compile: function() {
      return function linkFunction($scope, element) {
        const DataSet = vis.DataSet; // eslint-disable-line no-undef
        const Network = vis.Network; // eslint-disable-line no-undef

        $scope.crumbs = [];

        $scope.fitted = false;
        $scope.stabilized = false;
        $scope.currentNode = {};

        $scope.jobGraph = JSON.parse($scope.jobGraph);
        $scope.currentProject = '';
        $scope.currentJob = '';

        $scope.getJobExecutionData = function(projectName, jobName) {
          const matchingNodes = $scope.jobGraph.nodes
            .filter((obj) => obj.projectName === projectName && obj.jobName === jobName);

          let nodes = new DataSet(
            matchingNodes.map( (obj) => {
              const node = {
                id: obj.id,
                label: obj.name
              };

              if (obj.task && obj.task.taskType) {
                node.group = obj.task.taskType;
              } else {
                if (obj.objectType) {
                  node.group = obj.objectType;
                } else {
                  node.group = obj.nodeType;
                }
              }
              return node;
            })
          );

          const jobNode = matchingNodes.find(
            (obj) => obj.nodeType === 'Job' || obj.objectType === 'Job'
          );

          let edges = new DataSet($scope.jobGraph.edges);
          $scope.currentProject = projectName;
          $scope.currentJob = jobName;
          $scope.currentFinalizerTaskName = jobNode ? jobNode.finalizerTaskName : null;
          console.log('[finalizer debug]',
            'project:', projectName,
            'job:', jobName,
            'matchingNodes:', matchingNodes.length,
            'jobNode:', jobNode,
            'currentFinalizerTaskName:', $scope.currentFinalizerTaskName);
          return {nodes: nodes, edges: edges};
        };

        const nodesById = _.indexBy($scope.jobGraph.nodes, 'id');

        // create a network
        const container = element.find('.network')[0];

        // use rootNodeId to create initial job execution graph
        const rootProject = $scope.jobGraph.rootNodeId.split('.')[0];
        const rootJob = $scope.jobGraph.rootNodeId.split('.')[1];
        const data = $scope.getJobExecutionData(rootProject, rootJob);

        const options = {
          edges: {
            smooth: {
              type: 'cubicBezier',
              forceDirection: 'horizontal',
              roundness: 0.4
            },
            arrows: {
              to: true
            },
            arrowStrikethrough: false,
            color: {
              color: '#888',
              opacity: 1.0
            }
          },
          nodes: {
            shape: 'box'
          },
          interaction: {
            dragNodes: true,
            dragView: true,
            hideEdgesOnDrag: false,
            hideNodesOnDrag: false,
            hover: false,
            keyboard: {
              enabled: true,
              bindToWindow: false
            },
            multiselect: false,
            navigationButtons: true,
            selectable: true,
            selectConnectedEdges: false,
            hoverConnectedEdges: false,
            zoomView: false
          },
          layout: {
            hierarchical: {
              enabled: true,
              sortMethod: 'directed',
              levelSeparation: 230,
              direction: 'LR'
            }
          },
          autoResize: true,
          height: '450px',
          width: '100%',
          groups: {
            useDefaultGroups: true,
            Job: {
              shape: 'image',
              image: '/assets/images/flow/job.svg'
            },
            Task: {
              shape: 'image',
              image: '/assets/images/flow/flow_code.svg'
            },
            Script: {
              shape: 'image',
              image: '/assets/images/flow/flow_code.svg'
            },
            NestedJob: {
              shape: 'image',
              image: '/assets/images/flow/nested_job.svg'
            },
            SqlMapper: {
              shape: 'image',
              image: '/assets/images/flow/sql.svg'
            }
          }
        };

        $timeout(function() {
          let network = new Network(container, data, options);

          const onClick = (args, open) => {
            $timeout(function() {
              const id = args.nodes[0];
              $scope.currentNode = nodesById[id];
              if ($scope.currentNode.objectType) {
                $scope.currentNode.nodeType = $scope.currentNode.objectType;
              }
              if ($scope.currentNode.task && $scope.currentNode.task.nestedJobReference) {
                const nestedRef = $scope.currentNode.task.nestedJobReference;
                const downStream = $scope.jobGraph.nodes.filter((obj) =>
                  obj.projectName === nestedRef.projectName &&
                  obj.jobName === nestedRef.jobName &&
                  (obj.objectType === 'Job' || obj.nodeType === 'Job')
                );
                $scope.containsNestedJobGraph = downStream.length > 0;
                if (open && $scope.containsNestedJobGraph) {
                  $scope.openNewJob($scope.currentNode);
                }
              }
            });
          };

          $scope.initNetwork = function(network) {
            network.on('click', function(args) {
              onClick(args);
            });

            network.on('doubleClick', function(args) {
              onClick(args, true);
            });

            network.on('stabilizationIterationsDone', function() {
              $timeout(function() {
                $scope.network = network;
                $scope.stabilized = true;
                network.setOptions({
                  physics: false
                });
              });
            });

            network.on('afterDrawing', function() {
              if (!$scope.fitted) {
                network.fit();
                $scope.fitted = true;
              }
            });
          };

          $scope.initNetwork(network);

          // use nested job reference to open nested job graph
          $scope.openNewJob = function(node) {
            let newData = $scope.getJobExecutionData(node.task.nestedJobReference.projectName,
              node.task.nestedJobReference.jobName);
            let newNetwork = new Network(container, newData, options);
            $scope.initNetwork(newNetwork);
            $scope.currentNode = {};
            $scope.crumbs.push({'projectName': node.projectName, 'jobName': node.jobName});
          };

          // open job graph from qualified job name in bread crumb
          $scope.openJobFromCrumb = function(crumb) {
            let newData = $scope.getJobExecutionData(crumb.projectName, crumb.jobName);
            let newNetwork = new Network(container, newData, options);

            let i;
            let crumbIndex = 0;
            for (i = 0; i < $scope.crumbs.length; i++) {
              if ($scope.crumbs[i] === crumb) {
                crumbIndex = i;
              }
            }
            $scope.crumbs = $scope.crumbs.slice(0, crumbIndex);
            $scope.currentNode = {};

            $scope.initNetwork(newNetwork);
          };
        });
      };
    }
  };
}).
directive('magpieProject', function() {
  return {
    restrict: 'E',
    scope: {
      lineage: '=?',
      project: '=?',
      description: '=?',
      userPermissions: '=?'
    },
    templateUrl: 'components/magpie-display/flow/project.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.project = $scope.description.project;
        $scope.lineage = $scope.description.lineage;
        $scope.jobs = $scope.description.jobs;
        $scope.executionHistory = $scope.description.history;
        $scope.userPermissions = $scope.description.userPermissions;
      } else if ($scope.project) {
        $scope.jobs = $scope.project.jobs;
      }
      $scope.sortedJobs = _.sortBy($scope.jobs, 'name');
    }
  };
}).
directive('magpieJobScheduleDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-schedule-details.html',
    controller: function($scope) {
      if (!$scope.schedule) {
        $scope.schedule = $scope.description.schedule;
        $scope.user = $scope.description.user;
      }
    }
  };
}).
directive('magpieJobSchedule', function() {
  return {
    restrict: 'E',
    scope: {
      schedule: '=?',
      subscriptions: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/flow/job-schedule.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.schedule = $scope.description.schedule;
        $scope.user = $scope.description.user;
        $scope.executionHistory = $scope.description.history;
        $scope.subscriptions = $scope.description.subscriptions;
      }
    }
  };
}).
directive('magpieJobSchedules', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-schedules.html'
  };
}).
directive('magpieJobScheduleSubscription', function() {
  return {
    restrict: 'E',
    scope: {
      subscription: '=?',
      description: '=?'
    },
    templateUrl: 'components/magpie-display/flow/job-schedule-subscription.html',
    controller: function($scope) {
      if ($scope.description) {
        $scope.subscription = $scope.description.subscription;
      }
    }
  };
}).
directive('magpieJobScheduleSubscriptionDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-schedule-subscription-details.html'
  };
}).
directive('magpieJobScheduleSubscriptions', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-schedule-subscriptions.html'
  };
}).
directive('magpieJobMetrics', function() {
  return {
    restrict: 'E',
    scope: {
      jobMetrics: '=',
      isOpen: '=?'
    },
    templateUrl: 'components/magpie-display/flow/job-metrics.html'
  };
}).
directive('magpieJobHistory', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      jobHistory: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/flow/job-history.html',
    controller: function($scope) {
      $scope.executionHistory = _.sortBy($scope.jobHistory, (h) => -moment(h.startTime));
    }
  };
}).
directive('magpieJobHistoryDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/job-history-details.html',
    controller: function($scope) {
      $scope.records = _.sortBy($scope.executionHistory, (h) => -moment(h.startTime));
    }
  };
}).
directive('magpieJobRunTaskSummary', function() {
  return {
    restrict: 'AE',
    scope: {
      run: '=',
      logs: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/flow/job-run-task-summary.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      _.defaults($scope.jobRun, {
        timestamp: moment($scope.timestamp)
      });

      $scope.taskLogs = _.filter($scope.logs, (l) => l.taskRunId === $scope.run.taskRunId);
    }
  };
}).
directive('magpieTaskHistory', function() {
  return {
    restrict: 'E',
    scope: {
      label: '@',
      taskHistory: '=',
      timestamp: '@?'
    },
    templateUrl: 'components/magpie-display/flow/task-history.html',
    controller: function($scope) {
      $scope.executionHistory = _.sortBy($scope.taskHistory, (h) => -moment(h.startTime));
    }
  };
}).
directive('magpieTaskHistoryDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/flow/task-history-details.html',
    controller: function($scope) {
      $scope.startTimeComparator = function(v1, v2) {
        return moment(v1.value).diff(moment(v2.value)) < 0 ? -1 : 1;
      };
    }
  };
}).
directive('magpieJobRun', function() {
  return {
    restrict: 'AE',
    scope: {
      jobRun: '=',
      taskRuns: '=',
      logs: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/flow/job-run.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      $scope.getDisplayStackTrace = function() {
        const res = $scope.jobRun.result;
        if (!res) {
          return '';
        }
        if ($scope.expanded) {
          if (res.stackTrace) {
            return res.stackTrace;
          } else if (res.message) {
            return `${res.exceptionType}: ${res.message}`;
          } else {
            return res.exceptionType;
          }
        } else {
          if (res.stackTrace) {
            return res.stackTrace.substring(0, 100);
          } else if (res.message) {
            return `${res.exceptionType}: ${res.message}`.substring(0, 100);
          } else {
            return res.exceptionType.substring(0, 100);
          }
        }
      };

      $scope.shouldShowExpand = function() {
        return !$scope.expanded
          && $scope.jobRun.result
          && (($scope.jobRun.result.stackTrace
              && $scope.jobRun.result.stackTrace.length > 200)
          || ($scope.jobRun.result.message
              && $scope.jobRun.result.message.length > 200));
      };

      $scope.expanded = false;
      $scope.toggleExpand= function() {
        $scope.expanded = !$scope.expanded;
      };

      _.defaults($scope.jobRun, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
}).
directive('magpieTaskRunSummary', function() {
  return {
    restrict: 'AE',
    scope: {
      run: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/flow/task-run-summary.html',
    controller: function($scope) {
      _.defaults($scope.run, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
}).
directive('magpieTaskRun', function() {
  return {
    restrict: 'AE',
    scope: {
      run: '=',
      logs: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/flow/task-run.html',
    controller: function($scope, $element, $timeout, $controller) {
      angular.extend(this, $controller('MagpieExpandableRowCtrl', {
        $scope: $scope,
        $element: $element,
        $timeout: $timeout
      }));

      _.defaults($scope.run, {
        timestamp: moment($scope.timestamp)
      });
    }
  };
})
.controller('MagpieJobLogCtrl', function($scope) {
  _.defaults($scope.log, {
    eventTime: moment($scope.timestamp)
  });

  $scope.expanded = false;
  $scope.exceptionExpanded = false;
  $scope.toggleExpand= function(column) {
    if (column === 'stackTrace') {
      $scope.exceptionExpanded = !$scope.exceptionExpanded;
    } else if (column === 'message') {
      $scope.expanded = !$scope.expanded;
    }
  };

  $scope.isCodeMessage = $scope.log.eventType === 'TaskExecutionLog' ||
    $scope.log.eventType === 'TaskOutput';

  // Helper for message display
  $scope.getDisplayMessage = function() {
    const msg = ($scope.log.message || '').trim();
    if ($scope.expanded || msg.length <= 200) {
      return $scope.$parent.$eval('log.message | unspaceCurlyBraces');
    } else {
      return $scope.$parent.$eval('log.message | unspaceCurlyBraces | limitTo: 100');
    }
  };

  // Helper for exception details display
  $scope.getDisplayException = function() {
    const details = $scope.log.exceptionDetails;
    if (!details) {
      return '';
    }
    if ($scope.exceptionExpanded) {
      if (details.stackTrace) {
        return details.stackTrace;
      } else if (details.message) {
        return `${details.exceptionType}: ${details.message}`;
      } else {
        return details.exceptionType;
      }
    } else {
      if (details.stackTrace) {
        return details.stackTrace.substring(0, 100);
      } else if (details.message) {
        return `${details.exceptionType}: ${details.message}`.substring(0, 100);
      } else {
        return details.exceptionType.substring(0, 100);
      }
    }
  };

  $scope.shouldHideFullException = function() {
    return !$scope.exceptionExpanded
      && ($scope.log.exceptionDetails
        && (($scope.log.exceptionDetails.stackTrace
            && $scope.log.exceptionDetails.stackTrace.length > 200)
          || ($scope.log.exceptionDetails.message
            && $scope.log.exceptionDetails.message.length > 200)));
  };
}).
directive('magpieTaskLog', function() {
  return {
    restrict: 'AE',
    scope: {
      log: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/flow/task-log.html',
    controller: 'MagpieJobLogCtrl'
  };
}).
directive('magpieJobLog', function() {
  return {
    restrict: 'AE',
    scope: {
      log: '=',
      timestamp: '='
    },
    templateUrl: 'components/magpie-display/flow/job-log.html',
    controller: 'MagpieJobLogCtrl'
  };
}).
directive('magpieJobLogEventType', function() {
  return {
    restrict: 'E',
    scope: {
      eventType: '='
    },
    templateUrl: 'components/magpie-display/flow/job-log-event-type.html',
    controller: function($scope) {
      function getType(state) {
        switch (state) {
          case 'JobFinish':
          case 'TaskFinish':
            return 'success';
          case 'JobFailed':
          case 'TaskFailed':
          case 'MetadataError':
          case 'ExecutionError':
            return 'danger';
          case 'JobStart':
          case 'TaskStart':
            return 'info';
          default:
            return 'default';
        }
      }

      $scope.label = _.startCase($scope.eventType);
      $scope.type = getType($scope.eventType);
    }
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/flow/magpie-flow.js